import { Box, Typography, styled, Stack } from '@mui/material';
import { Document, Page } from 'react-pdf';
import { useState } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import testPdfFile from '../../assets/f_Logo_Guidelines.pdf';

const PagePDF = styled(Page)(({ theme }) => ({
    canvas: {
        width: '100% !important',
        height: 'auto !important',
    },
}));

const Image = styled('img')(({ theme }) => ({
    borderRadius: '15px',
    boxShadow: '0 0 25px 0 #b3bac7',
    'margin-left': 'auto',
    'margin-right': 'auto',
    maxWidth: '700px',
    width: '100%',
}));

const DocumentPreview = props => {
    console.log('props, ', props);

    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    const changePage = direction => {
        if (direction === 'forward') {
            if (pageNumber < numPages) {
                setPageNumber(pageNumber + 1);
            }
        } else {
            if (pageNumber !== 1) {
                setPageNumber(pageNumber - 1);
            }
        }
    };

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    return (
        <>
            <Box sx={{ margin: '20px' }}>
                {(props.viewDocument.type === 'image/jpg' ||
                    props.viewDocument.type === 'image/png' ||
                    props.viewDocument.type === 'image/jpeg') && (
                    <Image
                        style={{
                            'width': '100%',
                            'max-width': '700px',
                        }}
                        onContextMenu={e => {
                            e.preventDefault();
                        }}
                        src={props.viewDocument.url}
                    />
                )}
                {props.viewDocument.type === 'image/webp' && (
                    <img
                        alt="Showing selected document"
                        src={props.viewDocument.url}
                        onContextMenu={e => {
                            e.preventDefault();
                        }}
                        style={{
                            'width': '100%',
                            'max-width': '700px',
                        }}
                    />
                )}
                {props.viewDocument.type === 'application/pdf' && (
                    <Box>
                        <Document
                            file={props.viewDocument.url}
                            loading={
                                <div>
                                    <Typography>Loading...</Typography>
                                </div>
                            }
                            onLoadSuccess={onDocumentLoadSuccess}
                            onItemClick={e => {
                                e.preventDefault();
                            }}
                            onContextMenu={e => {
                                e.preventDefault();
                            }}
                        >
                            <PagePDF pageNumber={pageNumber} />
                        </Document>
                        <Box
                            sx={{
                                display: 'flex',
                                alignContent: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Stack
                                direction="row"
                                spacing={2}
                                sx={{
                                    display: 'flex',
                                    alignContent: 'center',
                                    justifyContent: 'center',

                                    width: '200px',
                                    border: '1px solid rgb(189, 189, 189)',
                                    padding: '12px',
                                    borderRadius: '8px',
                                }}
                            >
                                <ArrowBackIosIcon
                                    data-cy="prev-page"
                                    onClick={() => {
                                        changePage('backward');
                                    }}
                                    style={{
                                        color: 'rgb(189, 189, 189)',
                                        width: '0.75em',
                                        height: '0.75em',
                                        fontSize: '1.75em',
                                    }}
                                />
                                <Typography data-cy="page-num">
                                    {pageNumber} / {numPages}
                                </Typography>
                                <ArrowForwardIosIcon
                                    data-cy="next-page"
                                    onClick={() => {
                                        changePage('forward');
                                    }}
                                    style={{
                                        color: 'rgb(189, 189, 189)',
                                        width: '0.75em',
                                        height: '0.75em',
                                        fontSize: '1.75em',
                                    }}
                                />
                            </Stack>
                        </Box>
                    </Box>
                )}
            </Box>
        </>
    );
};

export default DocumentPreview;
